import { RouterProvider } from "react-router-dom";

import { LoadingScreen } from "@/shared/components";

import { router } from "./Router";

export function App() {
  // Until the router finishes its initial load it renders nothing at all, and a route with a
  // loader stays uninitialized until that loader settles — so a hard navigation to one would
  // otherwise show a blank document for the whole round trip. Routes without a loader
  // initialize synchronously and never reach this.
  return <RouterProvider router={router} fallbackElement={<LoadingScreen />} />;
}
